import React from 'react';
import { Check } from '~/ui/assets/icons';
import {
  StepIndicatorContainer,
  StepItem,
  StepCircle,
  StepLabel,
  StepConnector,
} from './StepIndicator.styles';

type StepIndicatorProps = {
  steps: readonly string[];
  current: number;
};

function StepIndicator({ steps, current }: StepIndicatorProps) {
  return (
    <StepIndicatorContainer data-testid="resolve-step-indicator">
      {steps.map((label, index) => {
        const completed = index < current;
        const active = index === current;
        const isLast = index === steps.length - 1;

        return (
          <StepItem key={label}>
            <StepCircle active={active} completed={completed}>
              {completed ? <Check /> : index + 1}
            </StepCircle>
            <StepLabel active={active} completed={completed}>
              {label}
            </StepLabel>
            {!isLast && <StepConnector filled={completed} />}
          </StepItem>
        );
      })}
    </StepIndicatorContainer>
  );
}

export default StepIndicator;